import { atom, selector } from "recoil";
import {
  createDataRequest,
  updateDataRequest,
  getPurposeListRequest,
} from "../../../api/controller/PermitController";
import { pageState } from "../../../state/GlobalState";
import { permissionState } from "../../../api/state/AuthState";

export const permitListState = atom({
  key: "permitListState",
  default: [],
});
export const permitPurposeState = atom({
  key: "permitPurposeState",
  default: {
    data: [],
    ovf: false,
  },
});

export const modalConfigDefault = { size: "lg", wizard: false };

export const permitFilterState = selector({
  key: "permitFilterState",
  get: () => [],
});

export const formModes = {
  create: [{ name: "Default Create", action: createDataRequest }],
  update: [{ name: "Default Update", action: updateDataRequest }],
  view: [{ name: "Default View" }],
};

export const permitDataStructureState = selector({
  key: "permitDataStructureState",
  get: ({ get }) =>
    [
      {
        label: "Name",
        type: "text",
        order: { table: 1, form: 1 },
        section: { label: "General Information", id: 1 },
        create: [{ enabled: true, size: { xs: 12, md: 6 } }],
        update: ["same_as:create.0"],
        view: ["same_as:create.0"],
      },
      {
        label: "Designation",
        type: "text",
        order: { table: 2, form: 2 },
        section: { label: "General Information", id: 1 },
        create: [{ enabled: true, size: { xs: 12, md: 6 } }],
        update: ["same_as:create.0"],
        view: ["same_as:create.0"],
      },
      {
        label: "Identification Number",
        type: "text",
        order: { table: 3, form: 4 },
        section: { label: "General Information", id: 1 },
        create: [{ enabled: true, size: { xs: 12, md: 6 } }],
        update: ["same_as:create.0"],
        view: ["same_as:create.0"],
      },
      {
        label: "Email",
        type: "email",
        order: { form: 3 },
        section: { label: "General Information", id: 1 },
        create: [{ enabled: true, size: { xs: 12, md: 6 } }],
        update: ["same_as:create.0"],
        view: ["same_as:create.0"],
      },
     
      {
        label: "Mobile Number",
        type: "text",
        order: { table: 4, form: 5 },
        section: { label: "General Information", id: 1 },
        create: [{ enabled: true, size: { xs: 12, md: 6 } }],
        update: ["same_as:create.0"],
        view: ["same_as:create.0"],
      },
      {
        label: "Purpose",
        type: "select",
        order: { table: 5, form: 6 },
        section: { label: "General Information", id: 1 },
        create: [{ enabled: true, size: { xs: 12, md: 6 } }],
        update: ["same_as:create.0"],
        view: ["same_as:create.0"],
        list: get(permitPurposeState),
        getRequest: getPurposeListRequest,
      }, 


      {
        label: "Security Pass Expiry",
        type: "datepicker",
        order: { form: 6.1 },
        section: { label: "Training & Pass Expiry Dates", id: 2 },
        create: [{ enabled: true, size: { xs: 12, md: 6 } }],
        update: ["same_as:create.0"],
        view: [
          {
            enabled: true,
            size: { xs: 12, md: 6 },
            dateFormat: "YYYY-MM-DD",
            options: {
              altInput: true,
              altFormat: "F j, Y",
              dateFormat: "Y-m-d",
            },
          },
        ],
      },

     
      {
        label: "Basic Fire Training Expiry",
        type: "datepicker",
        order: { form: 6.2 },
        section: { label: "Training & Pass Expiry Dates", id: 2 },
        create: [{ enabled: true, size: { xs: 12, md: 6 } }],
        update: ["same_as:create.0"],
        view: [
          {
            enabled: true,
            size: { xs: 12, md: 6 },
            dateFormat: "YYYY-MM-DD",
            options: {
              altInput: true,
              altFormat: "F j, Y",
              dateFormat: "Y-m-d",
            },
          },
        ],
      },
      {
        label: "Ariside Safety Training Expiry",
        type: "datepicker",
        order: { form: 6.3 },
        section: { label: "Training & Pass Expiry Dates", id: 2 },
        create: [{ enabled: true, size: { xs: 12, md: 6} }],
        update: ["same_as:create.0"],
        view: [
          {
            enabled: true,
            size: { xs: 12, md: 6 },
            dateFormat: "YYYY-MM-DD",
            options: {
              altInput: true,
              altFormat: "F j, Y",
              dateFormat: "Y-m-d",
            },
          },
        ],
      },

      {
        label: "Basic Fire Training",
        type: "file",
        order: { form: 7 },
        section: { label: "Documents", id: 3 },
        create: [{ enabled: true, size: { xs: 12, md: 6 } }],
        update: ["same_as:create.0"],
        view: ["same_as:create.0"],
      },
     
      {
        label: "Ariside Safety Training",
        type: "file",
        order: { form: 9 },
        section: { label: "Documents", id: 3 },
        create: [{ enabled: true, size: { xs: 12, md: 6 } }],
        update: ["same_as:create.0"],
        view: ["same_as:create.0"],
      },
      
      {
        label: "Security Pass Photo",
        type: "file",
        order: { form: 11 },
        section: { label: "Documents", id: 3 },
        create: [{ enabled: true, size: { xs: 12, md: 6 } }],
        update: ["same_as:create.0"],
        view: ["same_as:create.0"],
      },
      
      {
        label: "Passport Size Photo",
        type: "file",
        order: { form: 13 },
        section: { label: "Documents", id: 3},
        create: [{ enabled: true, size: { xs: 12, md: 6,  } }],
        update: ["same_as:create.0"],
        view: ["same_as:create.0"],
      },
      {
        label: "Identification Photo",
        type: "file",
        order: { form: 14 },
        section: { label: "Documents", id: 3 },
        create: [{ enabled: true, size: { xs: 12, md: 6, } }],
        update: ["same_as:create.0"],
        view: ["same_as:create.0"],
      },
     
      {
        label: "Status",
        type: "select",
        order: { table: 6, form: 14 },
        section: { label: "Status", id: 4 },
        create: [{ enabled: false }],
        update: ["same_as:create.0"],
        view: [{ enabled: true, size: { xs: 12, md: 12 } }],
        rootValue: true,
        list: {
          ovf: false,
          data: [
            { label: "PENDING", value: "PENDING" },
            { label: "AWAITING PAYMENT", value: "AWAITING PAYMENT" },
            { label: "ISSUED", value: "ISSUED" },
            { label: "EXPIRED", value: "EXPIRED" },
          ],
        },
      },

      
    ].filter((v) => {
      const page = get(pageState);
      const permissions = get(permissionState);
      if (!v.permission) {
        return true;
      }
      let absolute = false;
      if (v.permission.substr(0, 1) === ":") {
        absolute = true;
        v.permission = v.permission.substr(1);
      }
      v.permission = absolute ? v.permission : v.permission + "-" + page;
      return permissions?.includes(v.permission);
    }),
});
